import gql from "graphql-tag"

export const StatementItemContentFragment = gql`
  fragment StatementItemInfoFragment on StatementItemInfo {
    text
    values
    numberKeys
    currencyKeys
  }

  fragment StatementItemContentFragment on StatementItemContent {
    type
    image
    status
    title {
      ...StatementItemInfoFragment
    }
    subTitle {
      ...StatementItemInfoFragment
    }
    details {
      ...StatementItemInfoFragment
    }
  }
`
